export const SET_TOKEN = "SET_TOKEN";

export function setUserToken(data) {
	return {
		type: SET_TOKEN,
		payload: data,
	};
}